import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowLeft, Edit, Search, Send, Image, Smile } from 'lucide-react';
interface MessagesViewProps {
  onBack: () => void;
}
const mockConversations = [{
  id: '1',
  user: {
    name: 'Sarah Jenkins',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=100&q=80'
  },
  lastMessage: 'Love this design! Where did you find it?',
  time: '2m',
  unread: true,
  messages: [{
    id: 'm1',
    text: 'Hey! I saw your latest pin',
    fromMe: false,
    time: '10:30 AM'
  }, {
    id: 'm2',
    text: 'Thanks! I found it on a design blog',
    fromMe: true,
    time: '10:32 AM'
  }, {
    id: 'm3',
    text: 'Love this design! Where did you find it?',
    fromMe: false,
    time: '10:35 AM'
  }]
}, {
  id: '2',
  user: {
    name: 'Marcus Chen',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=100&q=80'
  },
  lastMessage: 'Thanks for sharing!',
  time: '1h',
  unread: false,
  messages: [{
    id: 'm1',
    text: 'Check out this interior design',
    fromMe: true,
    time: '9:00 AM'
  }, {
    id: 'm2',
    text: 'Thanks for sharing!',
    fromMe: false,
    time: '9:15 AM'
  }]
}, {
  id: '3',
  user: {
    name: 'Elena Rodriguez',
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=100&q=80'
  },
  lastMessage: 'Can you send me the link?',
  time: '3h',
  unread: false,
  messages: [{
    id: 'm1',
    text: 'I love your travel board!',
    fromMe: false,
    time: '6:00 AM'
  }, {
    id: 'm2',
    text: 'Thank you so much!',
    fromMe: true,
    time: '6:30 AM'
  }, {
    id: 'm3',
    text: 'Can you send me the link?',
    fromMe: false,
    time: '7:00 AM'
  }]
}, {
  id: '4',
  user: {
    name: 'David Kim',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=100&q=80'
  },
  lastMessage: 'Great collection!',
  time: '1d',
  unread: false,
  messages: [{
    id: 'm1',
    text: 'Great collection!',
    fromMe: false,
    time: 'Yesterday'
  }]
}];
export function MessagesView({
  onBack
}: MessagesViewProps) {
  const [selectedChat, setSelectedChat] = useState<(typeof mockConversations)[0] | null>(null);
  const [newMessage, setNewMessage] = useState('');
  const handleSend = () => {
    if (newMessage.trim()) {
      setNewMessage('');
    }
  };
  if (selectedChat) {
    return <motion.div initial={{
      x: '100%'
    }} animate={{
      x: 0
    }} exit={{
      x: '100%'
    }} className="fixed inset-0 bg-white z-50 flex flex-col" data-id="element-117">
        {/* Chat Header */}
        <div className="flex items-center gap-3 p-4 border-b border-gray-100" data-id="element-118">
          <button onClick={() => setSelectedChat(null)} className="p-2 -ml-2 hover:bg-gray-100 rounded-full" data-id="element-119">
            <ArrowLeft className="w-5 h-5" data-id="element-120" />
          </button>
          <img src={selectedChat.user.avatar} alt="" className="w-10 h-10 rounded-full object-cover" data-id="element-121" />
          <div className="flex-1" data-id="element-122">
            <p className="font-semibold text-gray-900" data-id="element-123">
              {selectedChat.user.name}
            </p>
            <p className="text-xs text-gray-500" data-id="element-124">Active now</p>
          </div>
        </div>

        {/* Messages */}
        <div className="flex-1 overflow-y-auto p-4 space-y-4" data-id="element-125">
          {selectedChat.messages.map(msg => <div key={msg.id} className={`flex ${msg.fromMe ? 'justify-end' : 'justify-start'}`} data-id="element-126">
              <div className={`max-w-[75%] px-4 py-2.5 rounded-2xl ${msg.fromMe ? 'bg-black text-white rounded-br-md' : 'bg-gray-100 text-gray-900 rounded-bl-md'}`} data-id="element-127">
                <p className="text-sm" data-id="element-128">{msg.text}</p>
                <p className={`text-xs mt-1 ${msg.fromMe ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-129">
                  {msg.time}
                </p>
              </div>
            </div>)}
        </div>

        {/* Input */}
        <div className="p-4 border-t border-gray-100 bg-white" data-id="element-130">
          <div className="flex items-center gap-2" data-id="element-131">
            <button className="p-2 text-gray-500 hover:text-black transition-colors" data-id="element-132">
              <Image className="w-5 h-5" data-id="element-133" />
            </button>
            <div className="flex-1 relative" data-id="element-134">
              <input type="text" placeholder="Message..." className="w-full px-4 py-3 bg-gray-100 rounded-full text-sm focus:bg-white focus:ring-2 focus:ring-gray-200 outline-none transition-all pr-10" value={newMessage} onChange={e => setNewMessage(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleSend()} data-id="element-135" />
              <button className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-black" data-id="element-136">
                <Smile className="w-5 h-5" data-id="element-137" />
              </button>
            </div>
            <button onClick={handleSend} disabled={!newMessage.trim()} className="p-2 text-black disabled:text-gray-300 transition-colors" data-id="element-138">
              <Send className="w-5 h-5" data-id="element-139" />
            </button>
          </div>
        </div>
      </motion.div>;
  }
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="fixed inset-0 bg-white z-50 flex flex-col" data-id="element-140">
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b border-gray-100" data-id="element-141">
        <button onClick={onBack} className="p-2 -ml-2 hover:bg-gray-100 rounded-full" data-id="element-142">
          <ArrowLeft className="w-5 h-5" data-id="element-143" />
        </button>
        <h1 className="font-bold text-lg" data-id="element-144">Messages</h1>
        <button className="p-2 -mr-2 hover:bg-gray-100 rounded-full" data-id="element-145">
          <Edit className="w-5 h-5" data-id="element-146" />
        </button>
      </div>

      {/* Search */}
      <div className="p-4" data-id="element-147">
        <div className="relative" data-id="element-148">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" data-id="element-149" />
          <input type="text" placeholder="Search messages" className="w-full pl-10 pr-4 py-2.5 bg-gray-100 rounded-full text-sm focus:bg-white focus:ring-2 focus:ring-gray-200 outline-none transition-all" data-id="element-150" />
        </div>
      </div>

      {/* Conversations */}
      <div className="flex-1 overflow-y-auto" data-id="element-151">
        {mockConversations.map(conv => <button key={conv.id} onClick={() => setSelectedChat(conv)} className="w-full flex items-center gap-3 p-4 hover:bg-gray-50 transition-colors text-left" data-id="element-152">
            <div className="relative" data-id="element-153">
              <img src={conv.user.avatar} alt="" className="w-14 h-14 rounded-full object-cover" data-id="element-154" />
              {conv.unread && <div className="absolute top-0 right-0 w-3.5 h-3.5 bg-red-500 rounded-full border-2 border-white" data-id="element-155" />}
            </div>
            <div className="flex-1 min-w-0" data-id="element-156">
              <div className="flex items-center justify-between gap-2" data-id="element-157">
                <p className={`truncate ${conv.unread ? 'font-bold text-gray-900' : 'font-medium text-gray-700'}`} data-id="element-158">
                  {conv.user.name}
                </p>
                <span className="text-xs text-gray-400 shrink-0" data-id="element-159">
                  {conv.time}
                </span>
              </div>
              <p className={`text-sm truncate mt-0.5 ${conv.unread ? 'text-gray-900 font-medium' : 'text-gray-500'}`} data-id="element-160">
                {conv.lastMessage}
              </p>
            </div>
          </button>)}
      </div>
    </motion.div>;
}